var React = require('react');

function IconEyeOpen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M511.8 212c-203.4 0-377.2 126.5-447.6 305.2 70.4 178.6 244.1 305.2 447.6 305.2S889 695.9 959.4 517.2C888.9 338.5 715.2 212 511.8 212zm0 508.6c-112.3 0-203.4-91.1-203.4-203.4s91.1-203.4 203.4-203.4 203.4 91.1 203.4 203.4c0 112.2-91.1 203.4-203.4 203.4zm0-325.5c-67.5 0-122.1 54.5-122.1 122.1 0 67.5 54.5 122.1 122.1 122.1s122.1-54.5 122.1-122.1c-.1-67.6-54.6-122.1-122.1-122.1z"}));
}

IconEyeOpen.displayName = "IconEyeOpen";

IconEyeOpen.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconEyeOpen;

IconEyeOpen.default = IconEyeOpen;
